import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectPhotosList } from '../../actions/selector';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Pipe({
    name: 'photoData',
    standalone: false
})
export class PhotoDataPipe implements PipeTransform {
  photosList$ = this.store.pipe(select(selectPhotosList));

  constructor(private store: Store) {}

  transform(photoId: string): Observable<{
    height: number;
    width: number;
    photoGroupHasPhotoId: string;
    photoId: string;
    photoGroupId: string;
    fileName: string;
  }> {
    return this.photosList$.pipe(
      map((photosList) => {
        let current = null;
        photosList.find(
          (photoList) =>
            (current = photoList.photos.find(
              (photo) => photo.photoId === photoId
            ))
        );
        return current;
      })
    );
  }
}
